import i18n from '../../decorators/i18n';
import nls from '../../locales/index.nls';
import BaseTable from './BaseTable';
import PromiseData from './PromiseData';
import LazyRendering from './LazyRendering';
import SortAble from './SortAble';
import Mix from '../../common/Mix';
import ColumnHider from './ColumnHider';
import ColumnFormatter from './ColumnFormatter';
import Selection from './Selection';
import Export from './Export';

// for inherit setter getter need define both
export default
@i18n(nls)
class KiTable extends Mix(
  BaseTable,
  LazyRendering,
  Selection,
  PromiseData,
  SortAble,
  ColumnHider,
  ColumnFormatter,
  Export,
) {


}

customElements.define('ki-table', KiTable);

// rework to col mode (selection
